import { render, staticRenderFns } from "./VideoModelSeo.vue?vue&type=template&id=00fbf1e7&scoped=true"
import script from "./VideoModelSeo.vue?vue&type=script&lang=js"
export * from "./VideoModelSeo.vue?vue&type=script&lang=js"
import style0 from "./VideoModelSeo.vue?vue&type=style&index=0&id=00fbf1e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fbf1e7",
  null
  
)

export default component.exports